var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      ref: "layout",
      attrs: {
        errors: _vm.errors,
        title: "",
        subtitle: "",
        breadcrumbs: _vm.breadcrumbs,
        helpForm: false,
        guest: _vm.guest || _vm.user,
        location: _vm.eventRegister.location,
      },
      scopedSlots: _vm._u([
        {
          key: "toggleFilter",
          fn: function () {
            return [
              _vm.shoppingCartItems
                ? _c(
                    "v-btn",
                    {
                      attrs: { icon: "", outlined: "", color: "white" },
                      on: {
                        click: function ($event) {
                          _vm.$inertia.visit(_vm.route("checkout.show"))
                        },
                      },
                    },
                    [
                      _c(
                        "v-badge",
                        {
                          attrs: {
                            content: _vm.shoppingCartItems,
                            color: "secondary",
                            overlap: "",
                            bordered: "",
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "white--text" }, [
                            _vm._v("shopping_cart"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-col",
        {
          staticClass: "white--text text-center px-0",
          attrs: { cols: "12", sm: "10", md: "8", lg: "6" },
        },
        [
          _c(
            "FormTitle",
            {
              staticClass: "pa-4 pt-0",
              attrs: { dark: "" },
              scopedSlots: _vm._u([
                {
                  key: "subtitle",
                  fn: function () {
                    return [
                      _c(
                        "v-list-item-avatar",
                        [
                          _c("v-img", {
                            attrs: {
                              src: _vm.eventRegister.details.teacher
                                .profile_photo_url,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(
                        _vm._s(`with ${_vm.eventRegister.details.teacher.name}`)
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _vm._v(
                _vm._s(_vm.eventRegister.group_event.title) + "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c("EventRegistrationDetails", {
            attrs: {
              eventRegister: _vm.eventRegister,
              errors: _vm.errors,
              user: _vm.user,
              autoCoupon: _vm.autoCoupon,
            },
          }),
          _vm._v(" "),
          !_vm.user
            ? _c("EventRegistrationGuest", {
                attrs: {
                  errors: _vm.errors,
                  guest: _vm.guest,
                  location: _vm.eventRegister.location,
                  eventRegister: _vm.eventRegister,
                },
                model: {
                  value: _vm.guestData,
                  callback: function ($$v) {
                    _vm.guestData = $$v
                  },
                  expression: "guestData",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.user || _vm.guest
            ? _c("EventRegistrationAttending", {
                attrs: {
                  relationships: _vm.relationships,
                  eventRegister: _vm.eventRegister,
                  user: _vm.user,
                  guest: _vm.guest,
                  guestData: _vm.guestData,
                  errors: _vm.errors,
                  autoCoupon: _vm.autoCoupon,
                },
                on: {
                  input: function ($event) {
                    return _vm.getDiscount($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }